import React, { Fragment } from "react";
import Navbar3 from "../../components/Navbar3/Navbar3";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import IndustryChallenges from "../../components/IndustryChallenges/IndustryChallenges";
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import CaseStudyCard from "../../components/CaseStudyCard/CaseStudyCard";
import SoftwareFeatures from "../../components/SoftwareFeatures/SoftwareFeatures";
import FeaturedBlogs from "../../components/FeaturedBlogs/FeaturedBlogs";
import RealEstateBusiness from "../../components/RealEstateBusiness/RealEstateBusiness";
import Footer from "../../components/footer/Footer";
import IconCard1 from "../../images/icon_card_19.png";
import IconCard2 from "../../images/icon_card_1.png";
import IconCard3 from "../../images/icon_card_3.png";
import IconCard4 from "../../images/icon_card_17.png";
import imageEcom from "../../images/img_ecom.png";

const ProjectPageS6 = () => {
  const solutions = [
    {
      title: "Inefficient Production & Supply Chain Management",
      problem:
        "Lack of real time tracking, outdated ERP systems, & inefficient workflows.",
      solution:
        "We integrate AI-powered ERP systems, IoT-based monitoring, and automated workflow solutions to streamline production and supply chain processes.",
    },
    {
      title: "Low Market Visibility & Customer Engagement",
      problem:
        "Weak digital presence, limited online lead generation, and ineffective marketing strategies.",
      solution:
        "Our SEO-optimized websites, PPC campaigns, and data-driven digital marketing strategies help manufacturers reach the right audience and increase sales.",
    },
    {
      title: "Difficulty in Managing Inventory & Logistics",
      problem:
        "Poor demand forecasting, stock mismanagement, and lack of data-driven decision-making.",
      solution:
        "We provide inventory management software, AI-based forecasting tools, and logistics automation to enhance operational efficiency and reduce waste.",
    },
  ];

  const services = [
    {
      title: "Web Development",
      description: [
        "Manufacturing ERP & supply chain platforms",
        "Industrial e-commerce & online product catalogs",
        "IoT-enabled production tracking dashboards",
        "Secure vendor & client management portals",
        "Custom web applications for automation",
      ],
      image: require("../../images/web-development-4.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
    {
      title: "Digital Marketing",
      description: [
        "SEO & content marketing for brand positioning",
        "PPC & paid advertising for lead generation",
        "Email & CRM automation for client engagement",
        "Social media marketing to enhance online presence",
        "Reputation & crisis management for brands",
      ],
      image: require("../../images/digital-marketing-4.png"),
      background: "linear-gradient(to bottom, #A240BF, #FECDCDCC)",
    },
  ];

  const features = [
    { title: "Smart factory & IoT monitoring UI/UX mockups", icon: IconCard1 },
    { title: "AI-driven production & logistics dashboards", icon: IconCard2 },
    { title: "Manufacturing analytics & automation reports", icon: IconCard3 },
    { title: "Industry 4.0 transformation infographics", icon: IconCard4 },
  ];

  const caseStudyData = {
    sectionTitle: "Success Stories in Manufacturing",
    sectionSubtitle:
      "Our AI-powered inventory management system reduced stock wastage by 40% in just 6 months!",
    image: require("../../images/cart/cart.png"),
    imageAlt: "E-commerce Case Study",
    title: "Establishment of an Ecom",
    description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    buttonText: "Read More",
    viewMoreText: "View More Case Studies ➜",
  };

  const realEstateData = {
    title: "Let’s Digitally Transform Your Manufacturing Business",
    description:
      "Boost efficiency, reduce costs, and scale operations with smart digital solutions.",
    buttonText: "Schedule a Strategy Call Today",
    image: require("../../images/business.png"),
  };

  const blogs = [
    {
      id: 1,
      title: "Establishment of an Ecom",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: imageEcom,
    },
    {
      id: 2,
      title: "We Setup a Mark to Identity",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work-1.png",
    },
    {
      id: 3,
      title: "Digitalization",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
      image: "/img/workshowcase/work.png",
    },
  ];

  const header =
    "Stay ahead of the latest trends in IT innovation, security, and digital transformation.";

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url('/img/solutionbg.jpeg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          position: "relative",
        }}
      >
        <Navbar3 topbarNone={"wpo-header-style-6"} />
        <PageTitle
          pageTitle={"Driving Manufacturing Excellence with Digital Innovation"}
          pageSub={
            "Optimize operations, boost efficiency, and enhance market reach with cutting-edge digital solutions tailored for the manufacturing industry."
          }
          backgroundImage={require("../../images/web-7.png")}
          buttonText={"Get a free consultation"}
        />
        <IndustryChallenges solutions={solutions} />
        <ServiceCard services={services} />
        {/* <CaseStudyCard caseStudy={caseStudyData} /> */}
        <SoftwareFeatures
          features={features}
          title={"Visualizing the Future of Manufacturing"}
          subTiltle={"When you team up with us for web development, you get"}
        />
        {/* <FeaturedBlogs blogs={blogs} header={header} /> */}
        <RealEstateBusiness
          title={realEstateData.title}
          description={realEstateData.description}
          buttonText={realEstateData.buttonText}
          image={realEstateData.image}
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          boxAlign="center"
          titleColor="#fff"
          descriptionColor="#fff"
        />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default ProjectPageS6;
